export default "__VITE_ASSET__8392b7f0__"